globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Sponsoring = appCustomerSpace.Controllers.Sponsoring || {};

appCustomerSpace.Controllers.Sponsoring.FaqController = (function(superClass)
{
    utils.extend(FaqController, superClass);

    function FaqController() {
      this.$search   = $("#faq-search-input");
      this.$tabs   = $(".question-item");
      return FaqController.__super__.constructor.apply(this, arguments);
    }

    $.extend(FaqController.prototype, {
        init: function() {
          this.search();

          return FaqController.__super__.init.apply(this, arguments);
        },
        search: function(){
          var _this = this,
              timeout = 0;

          _this.$search.on("change, keyup", function() {
            clearTimeout(timeout);

            timeout = setTimeout(function() {
              var search = _this.$search.val().toLowerCase();

              _this.$tabs.each(function() {
                var $tab     = $(this);
                var $label   = $tab.find(".question-label").text().toLowerCase();
                var $content = $tab.find(".question-response").text().toLowerCase();

                if($label.indexOf(search) > -1 || $content.indexOf(search) > -1) {
                  $tab.show();
                } else {
                  $tab.hide();
                }
              })

            }, 200);
          })
        }
    });

    return FaqController;

})(appCustomerSpace.Controllers.Sponsoring.MainController);
